import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    ContentSearch,
    BodyTextContainer1,
    SearchBoxContainer, 
    SearchTypeDropdownContainer,
    SearchTypeOptionLabel,
} from '../index.styled';
import SearchBox from 'src/common/refactoredComponents/searchbox/index';
import Select from 'src/common/refactoredComponents/select/Select';
import { SEARCH_TYPE_OPTIONS } from 'src/constants/fieldInventorySearchTypeConstants';
import { FONT_FAMILY_REGULAR } from 'src/styles/fonts/MCFontConstants';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend'; 

const SearchAndFilterContainer = ({ 
    searchText:searchParam, 
    onSearch = () => {},
    searchTypeOptions = SEARCH_TYPE_OPTIONS,
    getPlaceholder,
    searchLabel,
    searchId = 'fim',
    containerStyle,
    searchLabelFontSize,
    marginDesktop,
    truncateSearchTypeLabel = false
}) => {
    const { t } = useTranslation(); 
    const [searchText, setSearchText] = useState('');
    const [selectedSearchType, setSelectedSearchType] = useState(searchTypeOptions[0]); 

    const handleKeyPress = (event) => {
        try {
            if (event.key === 'Enter') {
                const term = event.target.value || '';
                const trimmedTerm = term.trim();
                setSearchText(trimmedTerm);
                if (!trimmedTerm) return;
                onSearch(trimmedTerm, selectedSearchType.code, false);
            }
        } catch (error) {
            logUiErrorToBackend(error, 'Search By Text - handle key press');
        }
    };

    const handleSearchTypeChange = (value) => {
        setSelectedSearchType(value);
        setSearchText(''); // Clear search text when dropdown changes
        if (searchText.trim()) {
            onSearch('', value.code, true);
        }
    };

    const clearSearch = () => {
        setSearchText('');
        onSearch('', selectedSearchType.code, true);
    };

    const searchPlaceholder = getPlaceholder
        ? getPlaceholder(selectedSearchType)
        : `${t('fieldInventoryDashboard.enter')} ${t(`fieldInventoryDashboard.searchTypePlaceholder.${selectedSearchType.code}`)}`;

    return (
        <ContentSearch style={containerStyle}>
            <BodyTextContainer1
                ipadMarginLeft={'0'}
                fontSize={searchLabelFontSize}>
                {searchLabel || t('fieldInventoryDashboard.search')}
            </BodyTextContainer1>
            <SearchTypeDropdownContainer>
                <Select
                    id={`${searchId}-search-type-dropdown`}
                    value={selectedSearchType}
                    options={searchTypeOptions}
                    onChange={handleSearchTypeChange}
                    optionLabel="label"
                    placeholder={t('fieldInventoryDashboard.selectSearchType')}
                    width={'100%'}
                    height={'40px'}
                    borderRadius={'6px'}
                    fontSize={'14px'}
                    selectedLabelFontSize={'14px'}
                    fontFamily={FONT_FAMILY_REGULAR}
                    smWidth={'100%'}
                    iPadwidth={'187px'}
                    hideClear={true}
                    truncateLabel={truncateSearchTypeLabel}
                    itemTemplate={(option) => (
                        <SearchTypeOptionLabel
                            truncate={truncateSearchTypeLabel}
                            title={truncateSearchTypeLabel && option ? t(option.label) : undefined}
                        >
                            {option ? t(option.label) : ''}
                        </SearchTypeOptionLabel>
                    )}
                    valueTemplate={(option) => (
                        <span>{option ? t(option.label) : ''}</span>
                    )}
                />
            </SearchTypeDropdownContainer>
            <SearchBoxContainer>
                <SearchBox
                    id={`${searchId}-searchbox`}
                    updateSearch={(val) => {
                        const trimmedValue = (val || '').trim();
                        if (!trimmedValue && searchText.trim()) {
                            onSearch('', selectedSearchType.code, true);
                        }
                        setSearchText(val);
                    }}
                    placeholder={searchPlaceholder}
                    width={'100%'}
                    height={'40px'}
                    borderRadius={'20px'}
                    isSearchIcon={true}
                    searchIconWidth={'min-content'}
                    fontSize={'14px'}
                    background={'none'}
                    enterkeyhint={'go'}
                    borderLeft={'none'}
                    labelColor="#040404"
                    fontWeight="400"
                    fontFamily="AvenirNextWorld, Regular"
                    padding={'0.5rem 2.2rem 0.6rem'}
                    marginDesktop={marginDesktop ? marginDesktop : '0'}
                    marginIpad={'0'}
                    autoComplete="off"
                    searchProduct={searchText}
                    handleKeyPress={handleKeyPress}
                    clearSearch={clearSearch}
                />
            </SearchBoxContainer> 
        </ContentSearch>
    );
};

export default SearchAndFilterContainer;
